import React, { useState, useEffect } from "react";
import Navbar from "@components/Navbar";
import Youtube from "@components/Youtube";
import FloatingMenu from "@components/FloatingMenu";

const Faq = () => {
  const [accordions, setAccordions] = useState([]);

  useEffect(() => {
    const fetchFaqData = async () => {
      try {
        const response = await fetch("https://cms.okoce.net/api/admin/frequently-asked-questions");
        const result = await response.json();
        const filteredFaqs = result.data.filter(faq => faq.published_at !== null);
        setAccordions(filteredFaqs);
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      }
    };

    fetchFaqData();
  }, []);

  const toggleAccordion = (index) => {
    setAccordions((prevAccordions) =>
      prevAccordions.map((accordion, i) => ({
        ...accordion,
        isOpen: index === i ? !accordion.isOpen : accordion.isOpen,
      }))
    );
  };

  return (
    <>
      <Navbar />
      <div className="mt-[5rem] bg-gray-100 w-full min-h-screen flex flex-col justify-between">
        <div className="container mx-auto mt-[3rem]">
          <h1 className="font-extrabold text-4xl text-center mb-8">
            Apa Saja Yang Sering Ditanyakan?
          </h1>
        </div>

        {/* Accordions section */}
        <div className="container mx-auto max-w-[60rem]">
          {accordions.map((accordion, index) => (
            <div
              className={`accordion-item bg-white rounded-lg mb-4 shadow-md ${accordion.isOpen ? "bg-gray-100" : ""}`}
              key={accordion.id}
              style={{ marginTop: "1rem" }}>
              <div
                className="accordion-title p-4 flex justify-between items-center cursor-pointer hover:bg-gray-200"
                onClick={() => toggleAccordion(index)}>
                <h3 className="font-bold">{accordion.question}</h3>
                <i className={`fas fa-chevron-down ${accordion.isOpen ? "chevron-top" : ""}`}></i>
              </div>
              {accordion.isOpen && (
                <div className="accordion-content p-4">
                  <p dangerouslySetInnerHTML={{ __html: accordion.answer }}></p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Video section */}
        <div className="flex flex-col items-center mt-10 mx-auto w-full">
          <h1 className="font-extrabold text-4xl text-center mb-4">Video Cara Daftar Akun</h1>
          <div className="mb-8 w-11/12 mobile:ml-8 lg:ml-32">
            <Youtube src="https://www.youtube.com/embed/DjF6FKYGYbU?si=Mzale-8dk2aNzbnM" />
          </div>
        </div>
      </div>
      <FloatingMenu />
    </>
  );
};

export default Faq;
